module.exports = __webpack_public_path__ + "fonts/SpecialElite-webfont.woff";